import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import NewsSection from './components/NewsSection';
import ProductGallery from './components/ProductGallery';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "JewelryStore",
      "name": "ジュエリーおかやま株式会社",
      "image": `${siteUrl}/store-image.jpg`,
      "description": "岡山市のオーダーメイドジュエリー専門店。ブライダルジュエリー、リメイク、修理まで対応。",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "北区○○町1-2-3",
        "addressLocality": "岡山市",
        "addressRegion": "岡山県",
        "postalCode": "700-0000",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 34.6617,
        "longitude": 133.9350
      },
      "telephone": "+81-86-012-3456",
      "faxNumber": "+81-86-012-3457",
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "09:00",
        "closes": "18:00"
      },
      "priceRange": "¥¥¥",
      "foundingDate": "2000",
      "url": siteUrl
    });
    document.head.appendChild(script);
    
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <NewsSection />
        <ProductGallery />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
